import { CommonKeys } from "../../../common/enums";
import type { StammElement } from "./StammElement";

export const STAMM_TASK_TYPE = "AM_Services.Domain.Models.Formulare.StammElementTask, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementTaskSchema = {
    $id: "FormularGroupStammStammElementTaskSchema",
    title: "FormularGroupStammStammElementTask Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_TASK_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementTask extends StammElement {
    Property: StammElementTaskProperty
}

export enum StammElementTaskProperty {
    TaskNo,
    Label,
}